'use client';

import { useProduct } from '@/entities/product';

import { Colors } from './Colors';
import { Fonts } from './Fonts';

export const PersonalizationVariants = () => {
    const { product } = useProduct();

    const personalization = product?.personalization;

    if (!personalization) return null;

    const colors = personalization.styleOptions?.threadColors;
    const fonts = personalization.fontFaceOptions;

    return (
        <>
            {colors && Boolean(colors.length) && (
                <div className="personalisation-variants">
                    <Colors colors={colors} />
                </div>
            )}
            {fonts && Boolean(fonts.length) && (
                <div className="personalisation-variants">
                    <Fonts fonts={fonts} />
                </div>
            )}
        </>
    );
};
